import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { copy } from 'ember-copy';

export default class IndexRoute extends Route {
  @service api;

  model() {
    return this.get('api').request('url_params');
  }

  setupController(controller, model) {
    let modelParams = model.url_params;

    controller.set('urlParams', copy(modelParams, true));
  }
}
